// extracted by mini-css-extract-plugin
module.exports = {"container":"_bd44b0d","collapse":"_cc122fe"};